// Account Modals
function accountmodals() {

    // if modal does not already exist, and not on the login page
    if( !$('#loginmodal').length && !$('#login-form').length ) {

        if( ! $('body').hasClass('pplogin') ) {
            $('body').append(loginmodalhtml);

            //_loginmodal.fadeIn(300);
            $(document).on("keyup", function (event) {
                if (event.keyCode == 27 && !!_loginmodal.find('.md-close').length) {
                    _loginmodal.find('.md-close').trigger('click');
                }
            });
            modalClose('#loginmodal');
            _loginmodal = $('#loginmodal');
            _login = $('#login-form', _loginmodal);
            _lost = $('#lost-form', _loginmodal);

            _login.validate({
                submitHandler: function(form) {
                    mloginpost(form);
                }
            });

            _lost.validate({
                submitHandler: function(form) {
                    mlostpost(form);
                }
            });

            $('body').addClass('pplogin');

        }

        $(document).on('click', '.loginbtn, .loginh>a', function(e){
            e.preventDefault();

            setTimeout(function() {
                $('#updates-guest, #registration-confirm, #waitlist-confirm').fadeOut(300);
            }, 300);

            modalOpen();
            _loginmodal
                .fadeIn(300)
                .find('input[autofocus]').trigger('focus');
        });
    }

    if( !$('#signupmodal').length && ! $('#signup-form').length && !$('#edit-form').length) {

        $('body').append(signupmodalhtml);
        initDateMask();
        //_signupmodal.fadeIn(300);
        $(document).on("keyup", function (event) {
            if (event.keyCode == 27 && !!_signupmodal.find('.md-close').length) {
                _signupmodal.find('.md-close').trigger('click');
            }
        });
        modalClose('#signupmodal');
        if (autofill) { autofill(); $('.autofiller').trigger('click'); }
        $('body').addClass('ppsignup');

        _signupmodal = $('#signupmodal');
        _signup = $('#signup-form', _signupmodal);

        $(document).on('click', '.signupbtn, .signupm>a', function(e){
            e.preventDefault();

            setTimeout(function() {
                $('#updates-guest, #registration-confirm, #waitlist-confirm').fadeOut(300);
            }, 300);

            modalOpen();
            _signupmodal
                .fadeIn(300)
                .find('input[autofocus]').trigger('focus');

        });

        _signup.validate({
            //errorElement: "span",
            messages: {
                firstname: {
                    //required: i18n.t('labels.errors.required'),
                    //letterswithbasicpunc: i18n.t('labels.errors.allowed_characters'),
                },
                lastname: {
                    //required: i18n.t('labels.errors.required'),
                    //letterswithbasicpunc: i18n.t('labels.errors.lastname.allowed_characters'),
                },
                password: {
                    //required: i18n.t('labels.errors.required'),
                    //minlength: $.validator.format(i18n.t('labels.errors.password_minlength')),
                },
                email: {
                    //required: i18n.t('labels.errors.required'),
                    //email: i18n.t('labels.errors.email_valid'),
                    //emailNeverbounce: i18n.t('labels.errors.email_valid'),
                },
                birthday: {
                    //required: i18n.t('labels.errors.required'),
                },
                gender: {
                    //required: _gendertext,
                },
                country: {
                    //required: i18n.t('labels.errors.required'),
                },
                homeevent: {
                    //required: i18n.t('labels.errors.required'),
                },
                accept_terms: {
                    required: _accepttext,
                },
            },
            rules: {
                email: {
                    required: true,
                    email: true,
                    //emailNeverbounce: true,
                },
                password: {
                    required: true,
                    minlength: 8,
                    maxlength: 100
                },
                firstname: {
                    required: true,
                },
                lastname: {
                    required: true,
                },
                birthday: {
                    completeDate: true,
                },
                gender: {
                    required: true,
                },
                country: {
                    required: true,
                },
                homeevent: {
                    required: true,
                },
                accept_terms: {
                    required: true,
                }
            },
            submitHandler: function(form, event) {
                msignuppost(form, event, this);
            }
        });

        homeEvents();

        // From login screen, switch to signup
        $(document).on('click', '.mlsignup', function(e){
            e.preventDefault();
            $('#loginmodal').fadeOut(300);
            $('#signupmodal')
                .fadeIn(300)
                .find('input[autofocus]').trigger('focus');
        });

        // From signup screen, switch to login
        $(document).on('click', '.mllogin', function(e){
            e.preventDefault();
            $('#signupmodal').fadeOut(300);
            $('#loginmodal')
                .fadeIn(300)
                .find('input[autofocus]').trigger('focus');
        });


        // From login screen, switch to lost password
        $(document).on('click', '#loginmodal .btn-lost', function(e){
            e.preventDefault();
            $('.loginhtml').fadeOut(300);
            setTimeout(function(){
                $('.forgothtml').fadeIn(300);
            }, 300)
        });


        // From signup screen, switch to signup
        $(document).on('click', '.back2login', function(e){
            e.preventDefault();
            $('.forgothtml').fadeOut(300);
            setTimeout(function(){
                $('.loginhtml')
                    .fadeIn(300)
                    .find('input[autofocus]').trigger('focus');
            }, 300)
        });


        var autotest = getUrlParam('at');

        if(autotest) {
            $('#signup-form input#firstname').val('Jamie');
            $('#signup-form input#lastname').val('Martin');
            $('#signup-form input#password').val('');
            $('#signup-form input#email').val('@ultra.us');
            $('#signup-form input#confirmemail').val('@ultra.us');
            $('#signup-form #birthday').val('04/24/2010');
            $('#signup-form select#country').val('US');
            $('#signup-form select#homeevent-signup').val('miami');
            setTimeout(function() { $('#signup-form select#homeevent').val('miami') }, 500);
            setTimeout(function() { $('#signup-form select#homeevent').val('miami') }, 2500);
            $('#signup-form #gender').val('male');
            $('#signup-form input#accept_terms').prop('checked', true);
        }
    }
}

function mloginpost(form) {
    hideResult();

    let form_data = Object.fromEntries(new FormData(form).entries());

    return uppLogin(form_data.loginemail, form_data.loginpassword)
    .then(function (data) {
        return $('#loginmodal').fadeOut(300);
    })
    .then(function (data) {
        return modalClosed();
    })
    .then(function (data) {
        var loginRedirect = $(form).data('redirect');
        if(loginRedirect) {
            window.location.assign(loginRedirect);
        }
    });
}

function mlostform() {

}


function mlostpost(form) {
    hideResult();

    let $form = $(form);
    $form.addClass('is-submitting');

    let form_data = Object.fromEntries(new FormData(form).entries());

    var email = form_data.lostemail;
    var mlocale = form_data.modlocale;
    var path = upp_page.reset_password;

    var redirect = $form.data('redirect');
    if(redirect !== undefined) {
        path += '?' + $.param({redirect: redirect});
    }

    return passport.sendReset(email, path, upp_page.signup, mlocale)
    .fail(function(jqXHR, textStatus, error){
        $(document).trigger('rebuild');
        if (jqXHR.status == 401) {
                //$(document).trigger('logged-out');
                showResult(_regerror, 'error');
            } else if (jqXHR.status == 409) {
                showResult(errors.duplicateemail, 'error');
            } else {
                showResult(errors.general, 'error');
            }
        })
    .done(function(data, textStatus, jqXHR){
        if (jqXHR.status == 401) {
            showResult(errors.general, 'error');
        } else {
            showResult(_passwordresetsent, 'success', { duration: 4000 });
        }
    });
}

function msignuppost(form, event, validator) {
    hideResult();

    let $form = $(form);
    let redirect = $form.data('redirect');
    $form.addClass('is-submitting');

    let form_data = Object.fromEntries(new FormData(form).entries());

    var sourceurl = document.location.hostname;
    var rcode = getUrlParam('rcode');
    if(rcode) {
        sourceurl = sourceurl + '?rcode=' + rcode;
    }

    let passport_data = {
        email: form_data.email,
        password: form_data.password,
        firstname: form_data.firstname,
        lastname: form_data.lastname,
        birthday: getDateISO(form.elements.birthday),
        gender: form_data.gender,
        country: form_data.country,
        homeevent: form_data.homeevent,
        lang: window.navigator.userLanguage || window.navigator.language,
        source: sourceurl,
    };

    _signupmodal = $('#signupmodal');

    passport.create(passport_data, $('#modlocale').val())
    .fail(function (jqXHR, textStatus, error) {
        $(document).trigger('rebuild');
        if (jqXHR.status == 400) {
            var responseJSON = jqXHR.responseJSON;

            if (responseJSON.errors) {
                //let errors = {};
                $.each(responseJSON.errors, (error_key, error) => {
                    //errors[error_key] = i18n.t(`labels.errors.${error_key}`);
                    //showResult(errors[error_key], 'error');
                    showResult(error, 'error');
                });
                validator.showErrors(responseJSON.errors);
                if (responseJSON.errors.birthday) {
                    showResult(errors.birthday, 'error');
                    $('#birthday').addClass('error');
                }

                if (responseJSON.errors.password) {
                    showResult(errors.password, 'error');
                    //$('#password').addClass('error');
                }
            }
        }
        else if (jqXHR.status == 409) {
            showResult(errors.duplicateemail, 'error');
        }
        else {
            showResult(errors.create, 'error');
        }
    })
    .done(function (data, textStatus, jqXHR) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'passport-create',
        });
        window.dataLayer.push({
            'event': 'sign_up',
            'method': 'passport'
        });

        scrollToTop();
        $('#password').removeClass('error');
        var _container = _signupmodal.find('.md-content .replacer');

        $('button.uppsignup')
            .addClass('working')
            .attr('disabled', 'disabled');

        showResult(_createdinfo, 'info');

        setTimeout(function () {
            _container.fadeTo(300, 0);
        }, 1000);

        setTimeout(function () {
            almost = almost.replace('$user_firstname', $('#signupmodal #firstname').val());
            almost = almost.replace('$user_email', $('#signupmodal #email').val());
            _container.html(`${almost}`);
            showResult(_createdinfo, 'info');
        }, 1300);

        setTimeout(function () {
            _container.fadeTo(300, 1);
        }, 1600);

        setTimeout(function () {
            scrollToTop();
            showResult(_createdsuccess, 'success');
                //log('created');
        }, 4000);

        setTimeout(function () {
            uppLogin(passport_data.email, passport_data.password).done(function () {
                setTimeout(function () {
                        //log(upp_page.verify);
                        sendVerify(upp_page.verify, redirect);
                    }, 2000);

                setTimeout(function () {
                    $('button.continue')
                        .removeClass('working')
                        .removeClass('disabled')
                        .removeClass('gray-btn')
                        .addClass('gold-btn')
                        .prop('disabled', false);

                    $('button.continue').on('click', function (e) {
                        e.preventDefault();
                        _signupmodal.fadeOut(300);
                        modalClosed();
                    });
                }, 3000);
            });
        }, 5500);
    });
}
